// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__R5JUD","disabled":"FileBtn_disabled__3IyVI","warn":"FileBtn_warn__mTFsR","fade":"FileBtn_fade__33Kk3"};